import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// MUI Imports
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  // Container,
  Grid,
  Paper,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const PostCampMonitoring = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const steps = ["Section One", "Section Two", "Section Three"];

  function navigateBack() {
    navigate("/home/monitoringandevaluation/dashboard");
  }

  function handleNextStep() {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  function handlePrevStep() {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }

  return (
    <Grid
      container
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid item xs>
        <Button
          variant="text"
          size="small"
          startIcon={<ArrowBackIosNewRoundedIcon fontSize="small" />}
          style={{
            textTransform: "none",
          }}
          onClick={navigateBack}
        >
          Back
        </Button>
      </Grid>
      <Grid
        item
        xs
        container
        style={{
          display: "flex",
          columnGap: "16px",
          flexDirection: "row",
          marginTop: "16px",
        }}
      >
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 1px 8px 0px #343C440D",
            backgroundColor: "white",
          }}
        >
          <Grid>
            <Typography
              variant="h6"
              style={{
                fontWeight: 600,
                color: "#212B36",
              }}
            >
              Sections
            </Typography>
            <Typography
              style={{ fontWeight: 400, color: "#52575C", fontSize: "12px" }}
            >
              Sections that are meant to be filled
            </Typography>
          </Grid>
          <Grid sx={{ mt: 4 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step) => (
                <Step key={step}>
                  <StepLabel>
                    <Typography
                      style={{
                        fontWeight: 400,
                        color: "#52575C",
                        fontSize: "12px",
                      }}
                    >
                      {step}
                    </Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
        </Grid>
        {/* <Grid> */}
        <Card
          style={{
            // display: "flex",
            // flexDirection: "column",
            // padding: "16px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 1px 8px 0px #343C440D",
            flexGrow: 1,
            height: "fit-content",
            // backgroundColor: "white",
          }}
        >
          <CardHeader
            title={
              <Typography
                variant="h6"
                style={{
                  fontWeight: 600,
                  color: "#212B36",
                }}
              >
                Quarterly Post Camp Monitoring Form
              </Typography>
            }
            subheader={
              <Typography
                style={{ fontWeight: 400, color: "#52575C", fontSize: "12px" }}
              >
                All sections marked with * are required.
              </Typography>
            }
          ></CardHeader>
          <CardContent
            style={{
              borderTop: "1px solid #E5E7EB",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            Ode o ode o ooo, ode ooo
          </CardContent>
          <CardActions
            style={{
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              size="small"
              endIcon={<ArrowForwardIosIcon fontSize="small" />}
              style={{
                textTransform: "none",
              }}
              // onClick={() => clickHandler(form.url)}
            >
              Next
            </Button>
          </CardActions>
        </Card>
        {/* </Grid> */}
      </Grid>
    </Grid>
  );
};

export default PostCampMonitoring;
